/**
 * @file components/biz/listPage/Filter
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import React from 'react';
import {Button} from 'acud';
import {OutlinedSearch} from 'acud-icon';
import _ from 'lodash';
import PropTypes from 'prop-types';

import FilterItem from './FilterItem';
import {DU_PREFIX} from '../../_common/constants';
import {FilterConfig} from './index';

import './index.less';

const CLS_PREFIX = `${DU_PREFIX}-filter`;

export interface FilterAreaProps {
    loading?: boolean;
    position?: string; // 如果是left代表放在一行左侧, 如果是right放在右侧
    filterComp?: React.ComponentType<any>;
    filterProps?: any; // 配对filterComp使用，最为props属性传入
    filterConfig?: FilterConfig;
    onHandleFilter: (filterData?: any) => void;
    onItemChange?: (changedItem: any) => void;
    onFilterDataChange?: (changedItem: any) => void;
}

export interface FilterAreaState {
    filterData: any; // 筛选内容
}

export default class FilterArea extends React.Component<FilterAreaProps, FilterAreaState> {

    static defaultProps = {
        position: ''
    };

    static propTypes = {
        loading: PropTypes.bool,
        position: PropTypes.string,
        filterComp: PropTypes.any,
        filterProps: PropTypes.any,
        filterConfig: PropTypes.object,
        onHandleFilter: PropTypes.func,
        onItemChange: PropTypes.func,
        onFilterDataChange: PropTypes.func
    };

    constructor(props: FilterAreaProps) {
        super(props);
        const filterData = {};
        const filterConfig = props.filterConfig;
        // 默认value赋值
        if (filterConfig && filterConfig.controls && filterConfig.controls.length) {
            _.each(filterConfig.controls, control => {
                if (control.name && !_.isNil(control.value)) {
                    filterData[control.name] = control.value;
                }
            });
        }
        this.state = {
            filterData
        };
    }

    // zhangzhe 2019-09-05 初始化筛选逻辑去除，在入口一定会发起请求
    // componentDidMount() {
    //     // 如果有默认值，更新state并且自动过滤一下
    //     const filterData = this.state.filterData;
    //     if (!_.isEmpty(filterData)) {
    //         this.handleFilter();
    //     }
    // }

    UNSAFE_componentWillReceiveProps(nextProps: FilterAreaProps) {
        const filterData = this.state.filterData;
        const lastFilterConfig = this.props.filterConfig;
        const nextFilterConfig = nextProps.filterConfig;
        if (lastFilterConfig && lastFilterConfig.controls
            && nextFilterConfig && nextFilterConfig.controls
            && !_.isEqual(lastFilterConfig.controls, nextFilterConfig.controls)) {
            // zhangzhe 2019-08-21 最后一个filter变化需要强制刷新数据
            const changedControls = _.filter(nextFilterConfig.controls,
                control => !_.isNil(control.value) && !_.isEqual(control.value, filterData[control.name]));
            const changedControlLength = changedControls.length;
            _.each(changedControls, (changedControl, index) => {
                // 当多个filter value变化的时候，只有最后一个改变的时候才会发起查询！避免多次查询的情况
                const forceFilterAction = (index === changedControlLength - 1);
                this.handleItemChanged(changedControl.value, changedControl.name, false, forceFilterAction);
            });
        }
    }

    handleItemChanged = (value: any, name: string, preventFilterAction = false, forceFilterAction = false) => {
        const {filterConfig, onItemChange, onFilterDataChange} = this.props;
        const submitText = (filterConfig as FilterConfig).submitText;
        this.setState(prevState => ({
            filterData: {...prevState.filterData, ...{[name]: value}}
        }), () => {
            // 抛出变化项
            onItemChange && onItemChange({name, value});
            // 强制更新数据优先级最高！
            if (forceFilterAction || (!submitText && !preventFilterAction)) {
                // 发起数据查询
                this.handleFilter();
            }
            else {
                // zhangzhe 2019-12-03 为了保证当前组件的filterData和useList中的filterData一致
                onFilterDataChange && onFilterDataChange({name, value});
            }
        });
    };

    handleFilter = () => {
        const onHandleFilter = this.props.onHandleFilter;
        const filterData = this.state.filterData;
        onHandleFilter(filterData);
    };

    render() {
        const {
            filterComp,
            filterProps,
            filterConfig,
            onHandleFilter,
            position,
            onItemChange,
            onFilterDataChange
        } = this.props;
        const filterData = this.state.filterData;

        if (filterComp) {
            if (typeof filterComp === 'function') {
                const Filter = filterComp;
                const customFilterProps = _.isObject(filterProps) ? filterProps : {};
                return (
                    <Filter
                        onHandleFilter={onHandleFilter}
                        onItemChange={onItemChange}
                        onFilterDataChange={onFilterDataChange}
                        {...customFilterProps}
                    />
                );
            }
            return filterComp;
        }
        else if (filterConfig && filterConfig.controls && filterConfig.controls.length) {
            const filterClassName = (position === 'left' || position === 'right')
                ? `${CLS_PREFIX} inline` : CLS_PREFIX;
            return (
                <div className={filterClassName}>
                    {_.map(filterConfig.controls, control => (
                        <FilterItem
                            key={`formItem_${control.name}`}
                            control={control}
                            filterData={filterData}
                            onItemChanged={this.handleItemChanged}
                        />
                    ))}
                    {filterConfig.submitText && (
                        <Button
                            type="primary"
                            icon={<OutlinedSearch />}
                            onClick={this.handleFilter}
                        >
                            {filterConfig.submitText}
                        </Button>
                    )}
                </div>
            );
        }
        return null;
    }
}
